import { defineMessages } from "react-intl";

import {
	diseasesMessages,
	hasDiseaseMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/nephrectomyOrGraftectomy";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	nephrectomyOrGraftectomy: {
		id: "ktx.form.nephrectomy_or_graftectomy",
		defaultMessage: "Nephrectomia vagy Graftectomia"
	},
	nephrectomyGraftectomyType: {
		id: "ktx.form.nephrectomy_or_graftectomy.type",
		defaultMessage: "Anamnézis"
	},
	hasDisease: {
		id: "ktx.form.nephrectomy_or_graftectomy.hasDisease",
		defaultMessage: "Betegség?"
	}
});

const fields: { [key: string]: FieldData } = {
	hasDisease: {
		type: "field",
		path: ["hasDisease"],
		label: messages.hasDisease,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: {
				labels: hasDiseaseMessages
			}
		}
	},
	nephrectomyGraftectomyType: {
		type: "field",
		path: ["diseases"],
		label: messages.nephrectomyGraftectomyType,
		errorMessages: genericErrorMessages,
		input: {
			type: "checkbox-group",
			props: {
				labels: diseasesMessages,
				columns: 2,
				direction: "vertical"
			}
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.hasDisease }] },
		{ columns: [{ width: 12, field: fields.nephrectomyGraftectomyType }] }
	]
};

export const node: LeafNode = {
	id: "ktx_nephrectomyOrGraftectomy",
	value: {
		schemaId: "nephrectomyOrGraftectomy",
		title: messages.nephrectomyOrGraftectomy,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
